module.exports = __webpack_public_path__ + "static/media/html.2169b9f5.png";